import request from "./request";

const leads = {
  service() {
    return {
      leadStats(brokerId, params) {
        return request.get(`/leads-api/leadstats/${brokerId}`, params);
      },
      getLeadZipCodes(params) {
        return request.get(`/leads-api/lead-supplier-zip-codes`, params);
      },
      getSupplierLeadLimits(params) {
        return request.get(`/leads-api/lead-supplier-limit`, params);
      },
      postSupplierLeadLimits(data) {
        return request.post(`/leads-api/lead-supplier-limit`, data);
      },
      patchSupplierLeadLimits(id, data) {
        return request.patch(`/leads-api/lead-supplier-limit/${id}`, data);
      },
      postLeadZipCodes(data) {
        return request.post(`/leads-api/lead-supplier-zip-codes/`, data);
      },
      deleteLeadZipCode(leadSupplierId, zipcode) {
        return request.delete(
          `/leads-api/lead-supplier-zip-codes/${leadSupplierId}/${zipcode}`,
        );
      },
      deleteLeadZipCodes(leadSupplierId, zipcodes) {
        return request.delete(
          `/leads-api/lead-supplier-zip-codes/${leadSupplierId}`,
          null,
          zipcodes,
        );
      },
    };
  },
};

export default leads;
